export const NEW = 'NEW';
export const VIEW = 'VIEW';
export const UPDATE = 'UPDATE';
export const DELETE = 'DELETE';
export const COPY = 'COPY';
export const READY = 'READY';
export const EDIT = 'EDIT';
export const UNLOCK = 'UNLOCK';
export const ADD_BENEFIT = 'Add benefit';
export const OPEN = 'Open';
export const REPORTS = 'Reports';
export const CALCULATE = 'CALCULATE';